import { ExportQuery } from './ExportQuery';

export class ExportBuilder {
  private _arguments = new Map<string, unknown | undefined>();
  private _required: string[] = [];
  public get reportId() {
    return this._arguments.get('reportId') as string | null | undefined;
  }

  constructor(reportId: string) {
    this._required = ['reportId', 'title', 'source', 'reportDefinition'];
    this._arguments.set('reportId', reportId);
    this._arguments.set('title', undefined);
    this._arguments.set('subtitle', undefined);
    this._arguments.set('source', undefined);
    this._arguments.set('reportDefinition', undefined);
  }

  public buildQuery(): ExportQuery {
    const errors = this.validate();
    if (errors.length === 0) {
      const keys = Array.from(this._arguments.keys());
      const query: Record<string, unknown | undefined> = {};
      for (const key of keys) {
        query[key] = this._arguments.get(key);
      }
      return query;
    } else {
      const error = errors[0];
      throw error;
    }
  }

  public set(field: string, value: unknown | undefined) {
    this._arguments.set(field, value);
  }

  public validate(): Error[] {
    const errorsFields = this._required.filter(field => this._arguments.get(field) === undefined);
    const errorsParameters: string[] = [];
    if (this._required.includes('reportDefinition') && errorsFields.length === 0) {
      const reportDefinition = this._arguments.get('reportDefinition') as any;
      const parameters = reportDefinition.parameters;
      for (const parameterId of Object.keys(parameters)) {
        const parameterValue = parameters[parameterId];
        const isNullOrUndefined = parameterValue === null || parameterValue === undefined;
        const isEmptyArray = Array.isArray(parameterValue) && !parameterValue.filter(Boolean).length;
        if (isNullOrUndefined || isEmptyArray) {
          errorsParameters.push(parameterId);
        }
      }
    }

    const errors = errorsFields.map(field => new Error(`Empty field ${field}`))
      .concat(errorsParameters.map(parameter => new Error(`Empty reportDefinition parameter ${parameter}`)));

    if (window.location.host.includes('localhost')) {
      window['debugInfo'] = {
        ...(window['debugInfo'] || {}), exportBuilder: {
          validator: {
            errors
          }
        }
      }
    }
    return errors;
  }
}